export default __webpack_public_path__ + "static/media/rei.f7eb0c09.svg";